import React, { useState, useRef, useEffect } from 'react';
import './Header.css';
import { useUser } from '../contexts/UserContext';

interface HeaderProps {
  title: string;
}

const Header: React.FC<HeaderProps> = ({ title }) => {
  const { user, logout, division, setDivisionModalOpen } = useUser();
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    setShowMenu(false);
    logout();
  };

  return (
    <>
      <header className="header">
      <div className="header-left">
        <img src="/logo.png" alt="Logo" className="logo-img" />
      </div>
      <div className="header-center">
        <h1 className="header-title">{title}</h1>
      </div>
      <div className="header-right">
        <button
          className={`dept-badge ${!division ? 'dept-badge--unset' : ''}`}
          onClick={() => setDivisionModalOpen(true)}
          title="Click to change division"
        >
          {division || 'Set Division'}
        </button>
        <div className="user-menu" ref={menuRef}>
          <button
            className="user-menu-trigger"
            onClick={() => setShowMenu(!showMenu)}
          >
            <div className="user-info">
              <span className="user-name">{user?.name || 'User'}</span>
              {user?.role && <span className="user-role">{user.role}</span>}
            </div>
            <span className="menu-arrow">▼</span>
          </button>
          {showMenu && (
            <div className="user-dropdown">
              <div className="dropdown-item profile-section">
                <div className="profile-email">{user?.email}</div>
              </div>
              <button className="dropdown-item logout-btn" onClick={handleLogout}>
                <span className="logout-icon">→</span> Log Out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
    <div className="header-accent-bar"></div>
    </>
  );
};

export default Header;
